
import { Editor } from '@tiptap/react';
import { mediaService, ImageLocation } from '@/services/mediaService';

export const useImageUploader = (editor: Editor | null) => {
  const uploadImage = async (file: File) => {
    if (!editor) return null;
    
    // Use the media service to upload the image
    const uploadedImage = await mediaService.uploadImage(file, {
      location: ImageLocation.ARTICLE_CONTENT,
      showToast: true
    });
    
    if (uploadedImage) {
      // Insert as custom image node
      editor.chain()
        .focus()
        .insertContent({
          type: 'customImage',
          attrs: { 
            src: uploadedImage.publicUrl, 
            alt: 'Article image',
            caption: '',
            alignment: 'center',
            width: '100%'
          }
        })
        .run();
      
      return uploadedImage.publicUrl;
    }
    
    return null;
  };
  
  return { uploadImage };
};
